import { profileMetadata } from '@/logic/stateReducers'
import { StoreState } from '@/store'
import { ProfileApiExport, ProfileEntry, ProfileImported, ProfileType, UserEntry } from '@/types/api'
import { Embed } from '@/types/embed'
import { publicName, PublicOptions } from './public-section'

export const buildCategories = {
  leveling: {
    name: 'Leveling',
    desc: 'Leveling'
  },
  endgame: {
    name: 'Endgame',
    desc: 'Endgame'
  }
}

export const buildTags = {
  hc: { name: 'HC' },
  ssf: { name: 'SSF' }
}

export const buildLeagues = {
  '325': 'Settlers of Kalguur',
  '326': 'Legacy of Phrecia',
  '3261': 'Mercenaries of Trarthus'
}

export type BuildCategory = keyof typeof buildCategories
export type BuildTag = keyof typeof buildTags
export type BuildSeason = keyof typeof buildLeagues

export const defaultSeason: BuildSeason = '3261'

export function exportProfile(
  state: StoreState,
  name?: string,
  publicOptions?: PublicOptions,
  type?: ProfileType
): ProfileApiExport {
  const data: any = { ...state }
  delete data.id

  data.embeds = state.embeds.map((embed) => ({ ...embed }))

  delete data.imported
  delete data.importedId
  delete data.user

  const result: ProfileApiExport = {
    data: type === 'pob' ? JSON.stringify({ pobCode: state.pobBuild?.code || '' }) : JSON.stringify(data),
    name: name ?? state.imported?.name ?? '',
    public: 0,
    folder: 0,
    type
  }

  if (state.planner && publicOptions) {
    if (!result.name) {
      result.name = publicName(state.planner.class, state.planner.ascendancy, publicOptions)
    }

    result.public = 1
    result.season = state.planner.version.toString()
    result.category = publicOptions.category
    result.tags = JSON.stringify(publicOptions.tags)

    result.metadata = JSON.stringify(profileMetadata(state.planner))
  }

  if (type !== 'pob' && state.planner) {
    result.type = 'planner'
    result.class = state.planner.ascendancy ?? state.planner.class
  } else {
    const embed = state.embeds.find((embed: Embed) => 'charClass' in embed)
    if (embed && 'charClass' in embed) result.class = embed.charClass
  }

  return result
}

export function entryFromExport(
  data: ProfileApiExport,
  id: string,
  user?: UserEntry,
  imported?: ProfileImported
): ProfileEntry {
  const { data: _, ...profileData } = data
  return {
    ...profileData,
    id,
    average_rating: imported?.id === id ? imported.average_rating : 0,
    total_ratings: imported?.id === id ? imported.total_ratings : 0,
    userRating: imported?.id === id ? imported.userRating : undefined,
    user,
    date: Date.now()
  }
}
